export default "__VITE_ASSET__DCRGIKTd__"